/* global Highcharts module window:true */
(function (factory) {
    if (typeof module === "object" && module.exports) {
        module.exports = factory;
    } else {
        factory(Highcharts);
    }
}(function (Highcharts) {

    Highcharts.wrap(Highcharts.Axis.prototype, "init", function (proceed, chart, userOptions) {
        proceed.call(this, chart, userOptions);

        this.imitateBrokenAxis = userOptions.imitateBrokenAxis;

        if (!this.horiz && this.imitateBrokenAxis) {
            var oldLabelFormatter = this.labelFormatter;
            this.labelFormatter = function () {
                if (this.isFirst) {
                    return 0;
                } else {
                    return oldLabelFormatter.call(this);
                }
            };
        }
    });

    Highcharts.wrap(Highcharts.Axis.prototype, "getLinePath", function (proceed, lineWidth) {
        var axis = this,
            path = proceed.call(this, lineWidth),
            x = path[1];

        if (!axis.horiz && axis.imitateBrokenAxis) {
            var y = axis.toPixels(axis.min) - 16;
            path.splice(3, 0,
                "L", x, y - 4, // stop
                "M", x + 5, y - 9, "L", x - 5, y + 1, // lower slanted line
                "M", x + 5, y - 1, "L", x - 5, y + 9, // higher slanted line
                "M", x, y + 4
            );
        }

        return path;
    });

}));
